module.exports = __webpack_public_path__ + "media/images/home/ic_meet-1f27c4c2acf689647dcffbffb2df6c16.svg";